import React, { Fragment } from 'react'

const AccountModal = ({ isVisible, onCloseModal, children }) => {
    return (
        <Fragment>
            {isVisible &&
                <Fragment>
                    <div className="account-modal-container modal">
                        { onCloseModal &&
                            <button
                                className="account-modal__close-button"
                                onClick={ () => onCloseModal() }
                            >
                                <i className="icon-cross" />
                            </button>
                        }
                        { children }
                    </div>
                    <div className="fog" onClick={ () => onCloseModal && onCloseModal() } />
                </Fragment>
            }
        </Fragment>
    )
}

export { AccountModal }
